"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMissouriRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'MO';

function getMissouriRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'State Employee Retirement. Highway and transportation employees. Special Consultants Pensions',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 104.540; Mo. Rev. Stat. § 104.250; Mo. Rev. Stat. § 104.610',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.STATE_EMPLOYEES_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Teachers',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 169.090',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TEACHERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 287.260',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Administrative Judges, Legal Advisors',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 287.820',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.JUDGES_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Property of Business partnership',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 358.250',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PARTNERSHIP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 377.090',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Employee Spendthrift Trust',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 456.014',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SPENDTHRIFT_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods. ' + 'Musical instruments. ' + 'Clothes. ' + 'Non-farm animals. ' + 'Crops.',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(1)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.HOUSEHOLD, _subTypes.MUSICAL_INSTRUMENT, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Retirement Plan',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(10) (f)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.PENSION_PLAN || tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.OTHER_RETIREMENT_PLAN || subType === _subTypes.RETIREMENT_PLAN || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Assistance, Earned Income Tax Credit (not child credit)',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(10)(a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.PUBLIC_ASSISTANCE || tertiaryType === _tertiaryTypes.INCOME_TAX_CREDIT);
    }
  }, {
    id: idCounter.increment(),
    description: "Veterans' Benefits",
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(10)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security. Unemployment. Disability Benefit',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(10)(c)',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.DISABILITY_BENEFITS, _tertiaryTypes.SOCIAL_SECURITY, _tertiaryTypes.UNEMPLOYMENT_BENEFITS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony and Child Support - to $750 per month',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(10)(d)',
    limitAggregateSingle: 750,
    limitAggregateJoint: 1500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Recoveries',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(11)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WRONGFUL_DEATH_AWARD];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wedding Rings',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(2)',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WEDDING_RINGS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry (other than wedding rings)',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(2)',
    limitAggregateSingle: 500,
    limitAggregateJoint: 1000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.JEWELRY, _subTypes.WATCH];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(4)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Automobiles',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(5)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.AUTOMOBILE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Motor home (one)',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(6)',
    limitAggregateSingle: 3000,
    limitAggregateJoint: 6000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.MOBILE_HOME;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unmatured life insurance',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(7)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefit (unmatured, loan, minus property transfered)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(8)',
    limitAggregateSingle: 150000,
    limitAggregateJoint: 300000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Firearms & Ammunition',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430. 1.(12)',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FIREARMS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages - 75% or 30 times the federal minimum hourly wage',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 525.030',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES;
    },
    transformFromContext: function transformFromContext() {// Wages (head of family) - 90% or 30 times the federal min hourly
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime Victim Compensation',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 595.025',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employee Retirement',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 70.695',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PUBLIC_EMPLOYEE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Police Employee Pension',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 86.190; Mo. Rev. Stat. § 86.353; Mo. Rev. Stat. § 86.1430',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Firefighter Pension',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 87.090; Mo. Rev. Stat. § 87.365; Mo. Rev. Stat. § 87.485',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.FIREFIGHTERS_PENSION;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'Mo. Rev. Stat. § 513.430 1.(3)',
    limitAggregateSingle: 600,
    limitAggregateJoint: 1250,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}